import React from 'react';
import { BreadcrumbFocusWrapper } from './BreadcrumbFocusWrapper';
export function BreadcrumbWrapper({ hasFocusContext, focusKey, children, }) {
    if (!hasFocusContext) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(BreadcrumbFocusWrapper, { focusKey: focusKey }, children);
}
